(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function addMotion(element, variant, delay) {
    if (!element || element.classList.contains('tvc6-motion')) return;
    element.classList.add('tvc6-motion');
    if (variant) element.classList.add('tvc6-motion--' + variant);
    element.style.setProperty('--tvc-delay', (delay || 0) + 'ms');
  }

  function init(root) {
    if (!root || root.dataset.tvcInteractions === 'ready') return;
    root.dataset.tvcInteractions = 'ready';

    addMotion(root.querySelector('.tvc__hero-content'), 'left', 40);
    addMotion(root.querySelector('.tvc__hero-media'), 'right', 130);

    root.querySelectorAll('.tvc__heading').forEach(function (element) {
      addMotion(element, 'up', 0);
    });

    addMotion(root.querySelector('.tvc6__hardware-image'), 'left', 50);
    root.querySelectorAll('.tvc6__spec-grid article').forEach(function (element, index) {
      addMotion(element, 'up', index * 65);
    });
    root.querySelectorAll('.tvc6__comparison-cards .tvc__price-card').forEach(function (element, index) {
      addMotion(element, 'up', index * 110);
    });

    root.querySelectorAll('.tvc6__audience').forEach(function (section) {
      var reverse = section.classList.contains('tvc6__audience--reverse');
      addMotion(section.querySelector('.tvc6__audience-image'), reverse ? 'right' : 'left', 30);
      var copy = section.querySelector('.tvc6__audience-copy');
      if (!copy) return;
      addMotion(copy.querySelector('.tvc__eyebrow'), 'up', 30);
      addMotion(copy.querySelector('h2'), 'up', 75);
      addMotion(copy.querySelector('.tvc6__audience-lead'), 'up', 115);
      copy.querySelectorAll('.tvc6__advantage-list article').forEach(function (element, index) {
        addMotion(element, 'up', 145 + index * 60);
      });
      addMotion(copy.querySelector('.tvc__button'), 'up', 220);
    });

    root.querySelectorAll('.tvc__faq-list details').forEach(function (element, index) {
      addMotion(element, 'up', Math.min(index * 45, 225));
    });
    addMotion(root.querySelector('.tvc6__faq-cta'), 'up', 80);

    var motionItems = root.querySelectorAll('.tvc6-motion');
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      motionItems.forEach(function (element) { element.classList.add('is-visible'); });
    } else {
      root.classList.add('tvc6--motion-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      motionItems.forEach(function (element) { observer.observe(element); });
      root.__tvcObserver = observer;
    }

    var progress = root.querySelector('.tvc6__progress span');
    var ticking = false;
    function updateProgress() {
      ticking = false;
      if (!progress || !root.isConnected) return;
      var rect = root.getBoundingClientRect();
      var total = Math.max(root.offsetHeight - window.innerHeight, 1);
      var travelled = Math.min(Math.max(-rect.top, 0), total);
      progress.style.transform = 'scaleX(' + (travelled / total).toFixed(4) + ')';
    }
    function requestProgress() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }
    window.addEventListener('scroll', requestProgress, { passive: true });
    window.addEventListener('resize', requestProgress, { passive: true });
    updateProgress();

    root.querySelectorAll('a[href^="#tvc-"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    root.__tvcCleanup = function () {
      window.removeEventListener('scroll', requestProgress);
      window.removeEventListener('resize', requestProgress);
      if (root.__tvcObserver) root.__tvcObserver.disconnect();
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.tvc6').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.tvc6');
    if (root && root.__tvcCleanup) root.__tvcCleanup();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (block) block.classList.add('is-visible');
  });
})();
